export class MapaAt {
    constructor() {}
    commonStep = 'stepper.form.commun.mapa.step';
    step = 'stepper.form.mapa_at.step';
  
  }
